import { Form, Input, Button, Card, message } from 'antd'
import { LockOutlined, MailOutlined, GlobalOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import axios from 'axios'
import '../i18n/i18n'

function AdminLogin({ onLogin }) {
  const { t, i18n } = useTranslation()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  const toggleLanguage = () => {
    const next = i18n.language === 'ar' ? 'en' : 'ar'
    i18n.changeLanguage(next)
    localStorage.setItem('app_language', next)
  }

  const handleLogin = async (values) => {
    setLoading(true)
    try {
      const res = await axios.post('/api/auth/admin/login', values)
      localStorage.setItem('adminToken', res.data.token)
      localStorage.setItem('admin', JSON.stringify(res.data.admin))
      message.success(t('login.welcomeMessage', { name: res.data.admin.name }))
      onLogin(res.data.admin)
    } catch (err) {
      message.error(err.response?.data?.error || t('login.loginError'))
    }
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#001529'
    }}>
      <Button
        icon={<GlobalOutlined />}
        onClick={toggleLanguage}
        style={{ position: 'absolute', top: 24, insetInlineEnd: 24 }}
      >
        {t('language.switchTo')}
      </Button>
      <Card
        style={{ width: 400, borderRadius: 12 }}
        title={
          <div style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold' }}>
            {t('adminLogin.title')}
          </div>
        }
      >
        <Form onFinish={handleLogin} layout="vertical">
          <Form.Item
            name="email"
            label={t('login.email')}
            rules={[
              { required: true, message: t('login.emailRequired') },
              { type: 'email', message: t('login.emailInvalid') }
            ]}
          >
            <Input prefix={<MailOutlined />} size="large" />
          </Form.Item>

          <Form.Item
            name="password"
            label={t('login.password')}
            rules={[{ required: true, message: t('login.passwordRequired') }]}
          >
            <Input.Password prefix={<LockOutlined />} size="large" />
          </Form.Item>

          <Button type="primary" htmlType="submit" block size="large" loading={loading}>
            {t('adminLogin.submit')}
          </Button>
        </Form>
      </Card>
    </div>
  )
}

export default AdminLogin
